import { useTranslation } from 'react-i18next';
import Table, { Column } from '../common/table';
import { Device, DeviceType } from '../../types/Device';
import { useNavigate } from 'react-router-dom';

export type Props = {
  devices: Device[];
};

export default function DeviceTable(prop: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: Column<Device>[] = [
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('sites.name')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td key={colI} className="px-6 py-2 text-left text-xs text-gray-500">
          {row.name}
        </td>
      ),
    },
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('sites.deviceType')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => {
        return (
          <td
            key={colI}
            className="whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500"
          >
            {deviceTypeLabelMap[row.type]}
          </td>
        );
      },
    },
    {
      renderHeader: (i: number) => (
        <th
          key={i}
          className="hide-on-mobile bg-gray-50 px-6 py-2 text-left text-sm font-semibold text-gray-900"
          scope="col"
        >
          {t('sites.notes')}
        </th>
      ),
      renderRow: (row, _rowI, colI) => (
        <td
          key={colI}
          className="hide-on-mobile whitespace-nowrap px-6 py-2 text-left text-xs text-gray-500"
        >
          {row.notes}
        </td>
      ),
    },
  ];

  const deviceTypeLabelMap = {
    [DeviceType.Summit]: t('device.summit'),
    [DeviceType.SummitCompressor]: t('device.summitCompressor'),
    [DeviceType.Bloom]: t('device.bloom'),
    [DeviceType.Pulse]: t('device.pulse')
  }

  const handleRowClick = (device: Device) => {
    navigate(`/sites/${device.siteId}/devices/${device._id}`);
  };

  return (
    <Table
      columns={columns}
      rows={prop.devices}
      title={t('fleets.devices')}
      currentPage={1}
      pageSize={1}
      totalRows={1}
      showPagination={false}
      onRowClick={(row) => handleRowClick(row)}
      removePadding={true}
    ></Table>
  );
}
